export default __webpack_public_path__ + "static/media/aib3.497ad571.svg";